<template>
  <v-dialog scrollable v-model="dialog" max-width="600px" class="max95">
    <template v-slot:activator="{ on }">
      <div class="pointer" :class="buttonClass" v-on="on">
        <v-btn text small color="primary">
            <v-icon small v-if="infoButton">mdi-information-outline</v-icon>
            <span v-else>{{ title }}
              <v-icon small class="ml-2">mdi-open-in-new</v-icon>
            </span>
          
          
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>More Info</v-card-title>
      <v-card-subtitle >
        Click a magnifying glass icon <v-icon small class="">mdi-magnify</v-icon> to search for all medications with that class or ingredient.
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text>
        <div v-for="(category, index) in categories" :key="index" class="my-4">
          <div class="sectionTitle text-h5 ">
            {{ category.name }} 
            <med-search-button :itemID="category.id" :itemName="category.name" :itemSlug="category.code" routeType="category">
            </med-search-button>
           
          </div>
          <div class="ma-2 subtitle-1">{{ category.description }}</div>

            <div v-if="itemsByCategoryId">
            <div
              v-for="item in itemsByCategoryId[category.id]"
              :key="item.id"
              class="ma-3  "
            >
              <div class="font-weight-bold">
                <v-icon x-small>mdi-bottle-tonic-plus-outline </v-icon>{{ item.name }}
                <med-search-button :itemID="item.id" :itemName="item.name"  routeType="ingredient">
            </med-search-button>
              </div>
              <div class="my-1 ml-6 subtitle-1">
                {{ item.description }}

              
              </div>
            </div>
          </div>
        

          <div
            v-for="(subcategory, index) in subcategories"
            :key="index"
            class="ma-2"
          >
            <div v-if="subcategory.parent_id == category.id">
              <div class="font-weight-black text-decoration-underline">
                {{ subcategory.name }}
                <med-search-button :itemID="subcategory.id" :itemName="subcategory.name" :itemSlug="subcategory.code" routeType="category">
            </med-search-button>
              </div>
              <div class="ma-2 subtitle-1">
                {{ subcategory.description }}
                
              </div>

               <div v-if="itemsByCategoryId">
                <div
                  v-for="item in itemsByCategoryId[subcategory.id]"
                  :key="item.id"
                  class="ma-3 font-weight-bold"
                >
                  <div class="font-weight-bold">
                    <v-icon x-small>mdi-bottle-tonic-plus-outline </v-icon> {{ item.name }}
                    <med-search-button :itemID="item.id" :itemName="item.name"  routeType="ingredient">
            </med-search-button>
                  </div>

                  <div class="my-1 ml-6 subtitle-1">
                    {{ item.description }}


                  </div>
                </div>
              </div> 
             
            </div>
          </div>
        </div>

       
      </v-card-text>

    
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import Slugify from "slugify";
// import MedSearchButton from './MedSearchButton.vue';

export default {
  components: { 
    MedSearchButton: () => import(/* webpackPrefetch: true */ './MedSearchButton'),
   },
  // components: { IngredientCard },
  
  name: "MoreDetailsDialog",
  props: {
    title: {
      type: String,
      default: "Ingredient and phramacology details",
    },
    items: null,
    categoryInfo: null,
    infoButton: {
      type: Boolean,
      default: false
    }
    // titleClass: {
    //   type:String,
    //   default: 'text-h6'
    // }
  },
  data: function() {
    return {
      dialog: false,
    };
  },
  methods: {
   
  },
  computed: {
    categories: function() {
      return this.categoryInfo?.categories;
    },
    subcategories: function() {
      return this.categoryInfo?.subcategories;
    },
    itemsByCategoryId: function() {
      if (!this.items) return null;
      let rtn = {};
      for (let item of this.items) {
        let catId = item.category_id;
        if (!rtn[catId]) rtn[catId] = [];
        rtn[catId].push(item);
      }
      return rtn;
    },
    buttonClass: function() {
      return this.infoButton ? "d-inline-block" : "d-block";
    }
    
  },
};
</script>

<style scoped>
.sectionTitle {
  background-color: #ffebc9;
  padding: 2px;
  margin-bottom: 10px;
  border-radius: 3px;
}
</style>
